import { combineReducers, configureStore } from '@reduxjs/toolkit';
import alertsSlice from '../slices/alertsSlice';
import authSlice from '../slices/authSlice';
import loadingSlice from '../slices/loadingSlice';
import errorsSlice from '../slices/errorsSlice';
import employeesSlice from '../slices/employeesSlice';
import employmentsSlice from '../slices/employmentsSlice';
import companiesSlice from '../slices/companiesSlice';
import negativesSlice from '../slices/negativesSlice';
import changesSlice from '../slices/changesSlice';
import ticketsSlice from '../slices/ticketsSlice';
import reportsSlice from '../slices/reportsSlice';
import notificationsSlice from '../slices/notificationsSlice';
import requirementsSlice from '../slices/requirementsSlice';

const rootReducer = combineReducers({
  auth: authSlice,
  alerts: alertsSlice,
  loading: loadingSlice,
  errors: errorsSlice,
  employees: employeesSlice,
  employments: employmentsSlice,
  companies: companiesSlice,
  negatives: negativesSlice,
  changes: changesSlice,
  tickets: ticketsSlice,
  reports: reportsSlice,
  notifications: notificationsSlice,
  requirements: requirementsSlice
});

const store = configureStore({ reducer: rootReducer });

export default store;
